<content class="hdmui-padding-0">

  <div class="container">
    <div class="row">
      <div class="col-sm-12  mb-3">
        <div class="hdmui p-3">
          <div>{{'AD_GROUPS' | translate}}:</div>
          <p>
            {{ adGroupNames }}
          </p>
        </div>
      </div>
      <div class="col-sm-12  mb-3">
        <div class="hdmui p-3">
          <div>{{'APP_ROLES' | translate}}:</div>
          <p>
            {{ appRoleIds }}
          </p>
        </div>
      </div>
      <div class="col-sm-12  mb-3">
        <div class="hdmui p-3">
          <div>{{'SSUS' | translate}}:</div>
          <p>
            {{ ssuList }}
          </p>
        </div>
      </div>
    </div>
  </div>


</content>